module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t0"
  }, [_vm._v("Praise for ")]), _c('span', {
    staticClass: "t1"
  }, [_vm._v("D.W. M")]), _c('span', {
    staticClass: "t2"
  }, [_vm._v("ARCHWELL")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t0"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t1"
  }, [_c('i', [_vm._v("Good to Know")])])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“It definitely appealed to the romantic in me.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—Book Wenches")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“I was completely enchanted.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—eHarlequin")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“A sweet romance.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—Elisa Rolle")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t1"
  }, [_c('i', [_vm._v("An Earlier Heaven")])])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“Marchwell has done yet another fantastic job with creating a story designed to draw the reader in and keep you compelled until the final sentence.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—Literary Nymphs")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“…a beautiful reminder to count your blessings no matter how big or small, and it will linger in your heart and mind long after the last page is turned.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—Whipped Cream Reviews")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t1"
  }, [_c('i', [_vm._v("Sins of the Father")])])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“The characters are strongly written and are sure to pull at the heartstrings of the readers.”")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("—Rainbow Reviews")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“A thought-provoking and touching story of love and second chances.” ")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—Book Wenches")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ac69130","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/002.vue
// module id = 57
// module chunks = 0